module.exports = __webpack_public_path__ + "static/img/2_1_7.a5dc22fc.jpg";